export class PbxNumbersEdit extends HTMLElement {
  constructor(group_id, domain_id, showList, reloadTable, data) {
    super();
    this.group_id = group_id;
    this.domain_id = domain_id;
    this.showList = showList;
    this.reloadTable = reloadTable;
    this.data = data;
    this.did_to_replace = null;
  }
  async connectedCallback() {
    this.innerHTML =
      `
      <style>
        pbx-numbers-edit input,
        pbx-numbers-edit select {
          margin-bottom: 20px;
        }

        .delete_number_did {
          margin-left: 20px;
        }
      </style>
      <div class="row pbx_number_form">
        <div class="col-sm-12 no-gutters">
          <h3><span id="pbx_number_back"></span> Edit Number</h3>
        </div>
        <div class="errors"></div>
        <div class="col-sm-7">
          <button class="btn btn-outline-danger delete_number_did pull-right">Delete</button>
        </div>
        <div class="col-sm-7">
          <div class="number_name_options">
            <label>Call Treatment</label>
            <input class="form-control number_new_name" placeholder="Name" value="${this.data.campaign_name}">
            <label>Call Treatment</label>
            <select is=treatments-select class="form-control call_treatments_id" data-cy="call-treat-id" domain_id="${this.domain_id}" data-selected="${this.data.target_id}"></select>
          </div>
        </div>
        <div class="number_did_container">
          ${this.data.did ? `<div class="col-sm-7">
                              <label>Phone Number</label>
                              <br>
                              <span>${this.data.did.toString().replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')}</span> <button class="btn btn-outline-danger replace_number_did">Replace</button>
                            </div>`
                            :
                            `<div class="col-sm-7">
                              <label>Select local or toll free number</label>
                            </div>
                            <pbx-number-picker data-required="true"></pbx-number-picker>`}
        </div>
        <div class="form-group col-sm-7 no-gutters" style="overflow:auto;">
          <button id="edit_number_save" class='btn btn-primary pull-right detail-row-button'>Save</button>
          <button id="edit_number_cancel" class='btn btn-outline-secondary pull-right detail-row-button'>Close</button>
        </div>
      </div>
      `;

    this.querySelectorAll('#edit_number_cancel, #pbx_number_back').forEach(e => {
      e.addEventListener('click', function() {
        this.hide();
      }.bind(this))
    })

    this.querySelector('#edit_number_save').addEventListener('click', function() {
      this.save();
    }.bind(this))

    if(this.data.did) {
      this.querySelector('.delete_number_did').addEventListener('click', function() {
        this.deleteNumber();
      }.bind(this))
    }
    if(this.data.did) {
      this.querySelector('.replace_number_did').addEventListener('click', function() {
        this.replaceNumber();
      }.bind(this))
    }
  }

  hide(){
    this.showList();
    this.remove();
  }

  validate() {
    let isValid = true;
    let errors = '';
    this.querySelector('.errors').innerHTML = '';
    this.querySelectorAll('.error').forEach(e => {
      e.classList.remove('error');
    })
    let validateNumber = this.querySelector('pbx-number-picker') ? this.querySelector('pbx-number-picker').validate() : {isValid:true};

    if(!this.querySelector('.number_new_name').value) {
      this.querySelector('.number_new_name').classList.add('error');
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> Please provide a name.
                                                </div>`;

      isValid = false;
    }
    if(!this.querySelector('.call_treatments_id').value) {
      this.querySelector('.call_treatments_id').classList.add('error');
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> Please select a call treatment.
                                                </div>`;

      isValid = false;
    }
    if(!validateNumber.isValid) {
      if(validateNumber.type == 'none') {
        errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                    <strong>Warning!</strong> Please select number type.
                                                  </div>`;
        } else if(validateNumber.type == 'toll-free') {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> Please select a toll free prefix.
                                                </div>`;
      } else if (validateNumber.type == 'local') {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> Please select a local number prefix.
                                                </div>`;
      }
      isValid = false;
    }

    this.querySelector('.errors').innerHTML = errors;
    return isValid
  }

  async deleteNumber() {
    if(await confirmPlus("Are you sure you want to delete this number?")) {
      let res = await fetch(`/admin/groups/${this.group_id}/pbx/${this.data.id}/delete_number`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'DELETE'
      })
  
      let response = await res.json();
      if(response.success) {
        Common.notify('Phone number deleted', 'success');
        this.reloadTable();
        document.querySelector('pbx-extensions').reloadTable();
        this.hide();
      } else {
        this.querySelector('.errors').innerHTML = `<div class="alert alert-danger alert-dismissible" role="alert">
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                    <strong>Warning!</strong> Unable to delete phone number.
                                                  </div>`
      }
    }
  }

  async replaceNumber() {
    if(await confirmPlus("Are you sure you want to replace this number?")) {
      this.did_to_replace = this.data.did;
      this.querySelector('.number_did_container').innerHTML = `<div class="col-sm-7">
                                                                  <label>Select local or toll free number</label>
                                                                </div>
                                                                <pbx-number-picker data-required="true"></pbx-number-picker>`
    }
  }

  async save() {
    if(!this.validate()) {
      return
    }
    
    let data = {
      target_id: this.querySelector('.call_treatments_id').value,
      did_to_replace: this.did_to_replace
    }

    if(this.querySelector('pbx-number-picker')) {
      let phone_number = this.querySelector('pbx-number-picker').getData();
      if(phone_number) {
        data.local_numbers = phone_number.local_numbers;
        data.npanxx = phone_number.npanxx;
      }
    }

    data.campaign_name = this.querySelector('.number_new_name').value;
    data.user_id = null;
    data.target_id = this.querySelector('.call_treatments_id').value;
    
    let res = await fetch(`/admin/groups/${this.group_id}/pbx/${this.data.id}/update_number`, {
      headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
      method: 'PUT',
      body: JSON.stringify(data)
    });
    let response = await res.json();
    if(response.success) {
      Common.notify('Number updated', 'success');
      this.reloadTable();
      document.querySelector('pbx-extensions').reloadTable();
      this.hide();
    } else {
      this.querySelector('.errors').innerHTML = `<div class="alert alert-danger alert-dismissible" role="alert">
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                    <strong>Warning!</strong> Unable to update number. ${response.error ? response.error : ""}
                                                  </div>`
    }
  }
}

customElements.define('pbx-numbers-edit', PbxNumbersEdit)